import { TabButton } from "@ui-kit/TabButton/TabButton";
import { FunctionComponent, useCallback } from "react";
import { ExternalIcon } from "@icons/ExternalIcon";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { useAppDispatch } from "@store/store";
import { openTripBuilder } from "@store/tripBuilder/tripBuilderReducer";

interface AiButtonProps {
  label?: string;
  flex: boolean;
}

export const AiButton: FunctionComponent<AiButtonProps> = ({ label, flex }) => {
  const dispatch = useAppDispatch();

  const onPress = useCallback(() => {
    dispatch(openTripBuilder());
  }, [dispatch]);

  return (
    <TabButton
      label={label}
      variant="ai"
      flex={flex}
      onPress={onPress}
      iconPrefix={
        <ExternalIcon
          testID="ai-icon"
          svgName="ai"
          size={16}
          color={colors.iconPrimary}
        />
      }
    />
  );
};
